import { createSlice } from "@reduxjs/toolkit";
import {
	setDashboard_,
	removeDashboard_,
	getDashboard_,
} from "../../lib/useLocalStorageDashboard";

const dashboardDetails = getDashboard_();

const CSPDashboardSlice = createSlice({
	name: "dashboard",
	initialState: dashboardDetails
		? dashboardDetails
		: {
				Heading: "",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: null,
				ConfirmOrder: false,
				OrderSummary: false,
		  },
	reducers: {
		getDashboard(state) {
			const dashboardData = getDashboard_();
			return { ...state, ...dashboardData };
		},
		setDashboard(state, action) {
			const dashboardData = { ...state, ...action.payload };
			setDashboard_(dashboardData);
			return dashboardData;
		},
		resetDashboard(state, action) {
			removeDashboard_();
			return null;
		},
	},
});

export const {
	getDashboard,
	setDashboard,
	resetDashboard,
} = CSPDashboardSlice.actions;

export default CSPDashboardSlice.reducer;
